import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
/*import 'font-awesome/css/font-awesome.min.css';*/
import "./assets/scss/zest-admin.css";
import "./assets/fonts/simple-line-icons.css";
import "./assets/css/app.css";
import indexRoutes from "./routes/index.jsx";
import { createStore } from "redux";
import { combine } from "./redux/reducer";
import { Provider } from "react-redux";

const store = createStore(combine);

const token = localStorage.getItem("AuthId");

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        {indexRoutes.map((prop, key) => {
          if (prop.collapse) {
            return prop.views.map((prop2, key2) => {
              return (
                <Route
                  path={prop2.path}
                  component={prop2.component}
                  key={key2}
                />
              );
            });
          }
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          // For GeneralLayout, don't use exact so it can handle all nested routes
          if (prop.path === "/" && prop.component && token) {
            return (
              <Route path={prop.path} component={prop.component} key={key} />
            );
          }
          return (
            <Route
              path={prop.path}
              component={prop.component}
              key={key}
              exact={prop.path !== "/"}
            />
          );
        })}
        {!token && <Redirect from="/" to="/login" />}
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
